// 商品カード共通のスクリプト。
// 以前は snippets/rouge-product-card.liquid の末尾に <script> として埋め込んでいたため、
// 商品カードの枚数ぶん（トップページで68回）同じコードがHTMLに出力されていた。
// ・HTMLが2.3KB×68回=153KB ふくらむ
// ・COMING SOON の setInterval が68個動く
// ・カラースワッチのクリックに68重のイベントが付く
// という3つの無駄があったため、外部ファイルに出して1回だけ読み込む形にした（2026-10-11）。

(function () {
  // ------------------------------------------------------------------
  // お気に入りハート（Swishアプリ）の位置ズレ対策
  // カードの上に重ねて表示されるが、スクロール途中や画像の遅延読み込みで
  // レイアウトが動くと、アプリ側の再計算が追いつかず位置がズレる。
  // こちらで位置を上書きするとアプリの共有レイヤーと衝突するため、代わりに
  // 要所で resize イベントを発火し、アプリ自身に正しい位置を再計算してもらう。
  // ------------------------------------------------------------------
  var rougeHeartNudge = function () {
    window.dispatchEvent(new Event('resize'));
  };

  // 全体読み込み後とその直後に数回
  window.addEventListener('load', function () {
    rougeHeartNudge();
    setTimeout(rougeHeartNudge, 500);
    setTimeout(rougeHeartNudge, 1500);
  });

  // 各商品画像の読み込み完了時
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rouge-product__image img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', rougeHeartNudge, { once: true });
      }
    });
  });

  // スクロールが止まったら再配置を促す（位置は基本CSSで固定しているため軽めに）
  var rougeScrollTimer;
  window.addEventListener(
    'scroll',
    function () {
      clearTimeout(rougeScrollTimer);
      rougeScrollTimer = setTimeout(rougeHeartNudge, 120);
    },
    { passive: true }
  );

  // ------------------------------------------------------------------
  // 販売開始時刻を過ぎた COMING SOON バッジ／販売開始日時を、キャッシュされた
  // 古いHTMLでもクライアント側で自動的に消す（data-coming-ts は UNIX 秒）。
  // ------------------------------------------------------------------
  var hideExpiredComing = function () {
    var nowSec = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-coming-ts]').forEach(function (el) {
      var ts = parseInt(el.getAttribute('data-coming-ts'), 10);
      if (ts && nowSec >= ts) {
        el.remove();
      }
    });
  };
  hideExpiredComing();
  // 開いたまま販売開始時刻をまたいだ場合にも反映
  setInterval(hideExpiredComing, 30000);

  // ------------------------------------------------------------------
  // カラースワッチ：クリックで該当カラーの画像に切り替える
  // ------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rouge-product__wrap').forEach(function (productWrap) {
      var swatches = productWrap.querySelectorAll('.rouge-product__swatch-item');
      var images = productWrap.querySelectorAll('.rouge-variant-image');

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var variantId = swatch.dataset.variantId;

          images.forEach(function (img) {
            img.classList.remove('is-active');
            if (img.dataset.variantId === variantId) {
              img.classList.add('is-active');
            }
          });

          swatches.forEach(function (s) {
            s.classList.remove('is-active');
          });
          swatch.classList.add('is-active');
        });
      });

      var defaultImage = productWrap.querySelector('[data-variant-id="default"]');
      if (defaultImage) {
        defaultImage.classList.add('is-active');
      }

      var firstSwatch = swatches[0];
      if (firstSwatch) {
        firstSwatch.classList.add('is-active');
      }
    });
  });
})();
